import { Injector, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { ApiService } from './shared/services/api.service';
import { AlertService } from './shared/services/alert.service';
import { HelperService } from './shared/services/helper.service';
import { SessionService } from './shared/services/session.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_BASE_HREF } from '@angular/common';
import { FooterComponent } from './shared/modules/footer/footer.component';
import { environment } from 'src/environments/environment';
import { OktaAuthModule, OKTA_CONFIG } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { Router } from '@angular/router';
import { BlockUIModule } from 'ng-block-ui';
import { HeaderComponent } from './shared/modules/header/header.component';
import { AuthService } from './shared/services/auth.service';
import { AuthGuard } from './auth-guard.guard';
import { APIInterceptor } from './api-interceptor';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
@NgModule({
  declarations: [AppComponent, FooterComponent, HeaderComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    BrowserAnimationsModule,
    ToastModule,
    HttpClientModule,
    OktaAuthModule,
    BlockUIModule.forRoot(),
    OverlayPanelModule,
    TooltipModule,
    DialogModule,
    ButtonModule,
  ],
  providers: [
    AuthGuard,
    MessageService,
    ApiService,
    AlertService,
    HelperService,
    AuthService,
    SessionService,
    {
      provide: OKTA_CONFIG,
      useFactory: () => {
        const oktaAuth = new OktaAuth(environment.Okta.oidc);
        oktaAuth.start();
        return {
          oktaAuth,
          onAuthRequired: (oktaAuth: OktaAuth, injector: Injector) => {
            const triggerLogin = () => {
              // Redirect the user to your custom login page
              const router = injector.get(Router);
              router.navigate([environment.Okta.loginURL]);
            };
            if (
              !oktaAuth.authStateManager.getPreviousAuthState()?.isAuthenticated
            ) {
              // App initialization stage
              triggerLogin();
            } else {
              triggerLogin();
            }
          },
        };
      },
    },
    { provide: APP_BASE_HREF, useValue: environment.Okta.appBaseHref },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: APIInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
